import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    padding-bottom: ${theme.spacings.small};
    padding-top: ${theme.spacings.small};
  `}
`;
